import request from '@/utils/request';
import { formDataProps, TopUPListParme } from '@/interface/top-up-active';

/**
 * 兑换码列表
 */
export const getTopUPList = async (params: TopUPListParme): Promise<any> => {
  return request({
    params,
    method: 'get',
    url: '/api/v1/omc/activity/marketing/list',
  });
};

/**
 * 活动启用禁用切换
 */
export const getChangeActiveStatus = async (params: { id: number | string; enabled: boolean }): Promise<any> => {
  return request({
    data: params,
    method: 'put',
    url: '/api/v1/omc/activity/marketing/enabled',
  });
};

/**
 * 活动启用禁用切换
 */
export const getActiveDetail = async (params: { id: number | string }): Promise<any> => {
  return request({
    params,
    method: 'get',
    url: '/api/v1/omc/activity/marketing',
  });
};

/**
 * 活动修改
 */
export const postEditActive = async (params: formDataProps): Promise<any> => {
  return request({
    data: params,
    method: 'post',
    url: '/api/v1/omc/activity/marketing',
  });
};

/**
 * 活动档位列表
 */
export const getGradesOptions = async (params: {
  kind: string;
  out_first_charging?: string; //是否去除首充档 传1表示去除，无此参数或空字符串则不去除
  client?: number;
}): Promise<any> => {
  return request({
    params,
    method: 'get',
    url: '/api/v1/omc/activity/marketing/grades',
  });
};

/**
 * 活动用特殊商品列表
 * @param params
 * @returns
 */
export const getValidSpecialGoods = async (params: { page?: number; page_size?: number }): Promise<any> => {
  return request({
    params,
    method: 'get',
    url: '/api/v1/omc/special_good/valid_list',
  });
};
